var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("app-divider", { attrs: { label: "Documentos" } }),
      _c(
        "div",
        { staticClass: "px-10" },
        [
          _c(
            "el-table",
            {
              attrs: {
                "cell-style": { padding: "0", height: "5px" },
                data: _vm.documentos
              }
            },
            [
              _c("el-table-column", {
                staticClass: "tes",
                attrs: { label: "Tipo de documento", formatter: _vm.getTipo }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Nome do arquivo:",
                  formatter: _vm.getNomeDocumento
                }
              }),
              _c("el-table-column", {
                attrs: { label: "Ações", prop: "valor", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("app-action-button", {
                          attrs: {
                            icone: "download",
                            text: "Download",
                            fontSize: "18"
                          },
                          on: {
                            click: function($event) {
                              return _vm.baixarDocumento(scope.row)
                            }
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-241bb12b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-241bb12b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/common/ListagemDocumentos.vue
// module id = null
// module chunks = 